import { render, staticRenderFns } from "./ObjectContracts.vue?vue&type=template&id=f233609e&scoped=true&"
import script from "./ObjectContracts.vue?vue&type=script&lang=js&"
export * from "./ObjectContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f233609e",
  null
  
)

export default component.exports